import { render, staticRenderFns } from "./EditPaymentMethods.vue?vue&type=template&id=06f86a7f"
import script from "./EditPaymentMethods.vue?vue&type=script&lang=js"
export * from "./EditPaymentMethods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports